import React from 'react';

const SentinelAlert = ({ vm }) => {
  if (!vm.sentinelFlags || vm.sentinelFlags.length === 0) {
    return null;
  }

  const styles = {
    container: {
      marginBottom: '24px',
      padding: '20px',
      background: '#fef2f2',
      border: '2px solid #fca5a5',
      borderRadius: '12px'
    },
    title: {
      fontSize: '1.125rem',
      fontWeight: '700',
      color: '#dc2626',
      marginBottom: '12px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    icon: {
      fontSize: '1.25rem'
    },
    list: {
      margin: 0,
      paddingLeft: '20px',
      color: '#7f1d1d'
    },
    listItem: {
      marginBottom: '8px',
      lineHeight: '1.5'
    }
  };

  return (
    <div style={styles.container} role="alert">
      <h3 style={styles.title}>
        <span style={styles.icon}>⚠️</span>
        Atenção Imediata Necessária
      </h3>
      <ul style={styles.list}>
        {vm.sentinelFlags.map((flag, i) => (
          <li key={i} style={styles.listItem}>{flag}</li>
        ))}
      </ul>
    </div>
  );
};

export default SentinelAlert;